common = require './common'

# Find elements ---------------------------------

# -> or(element, null)
scriptElement = ->
  scripts = document.getElementsByTagName("script")
  if scripts.length > 0
    scripts[scripts.length - 1]
  else
    null

# string (element -> void) -> void
eachElement = (markerAttr, callback) ->
  if document.querySelectorAll
    for elem in document.querySelectorAll("[#{markerAttr}]")
      callback(elem)
  else
    visit = (elem) ->
      if elem.hasAttribute(markerAttr)
        callback(child)
      else for child in elem.children
        visit(child)
      return
    visit(document.body)
  return

# Element data ----------------------------------

# element -> string
scriptBase = (scriptElem) ->
  linkElem = document.createElement("a")
  linkElem.setAttribute("href", scriptElem.getAttribute("src"))
  if linkElem.port == ""
    "#{linkElem.protocol}//#{linkElem.hostname}"
  else
    "#{linkElem.protocol}//#{linkElem.hostname}:#{linkElem.port}"

# element [string] -> objectOf(string, string)
elementData = (elem, prefix = undefined) ->
  prefix = if prefix then "data-#{prefix}" else "data"
  prefix = if prefix[prefix.length - 1] == "-" then prefix else "#{prefix}-"

  ans = {}
  for attr in elem.attributes
    prefixedName = attr.nodeName
    value        = attr.value
    if prefixedName.indexOf(prefix) != 0 then continue
    unprefixedName = common.intercap(prefixedName.substring(prefix.length))
    ans[unprefixedName] = value

  ans

# DOM ready -------------------------------------

# (-> void) -> void
onDomReady = (callback) ->
  if window.jQuery
    window.jQuery(callback)
  else if document.readyState == "complete"
    callback()
  else
    document.addEventListener('DOMContentLoaded', callback)
  return

# Bootstrap -------------------------------------

# element string [or(string, undefined)] -> void
#
# prefix is:
#   - undefined - don't read options from the target element
#   -
createIframe = (element, baseUrl, options = {}) ->
  query = []
  for name, value of options when value? && value != ''
    query.push("#{common.paramName(name)}=#{common.paramValue(value)}")
  sep = if /[?]/.test(url) then '&' else '?'
  url = [ baseUrl, query.join("&") ].join(sep)
  element.innerHTML = """<iframe src="#{url}" allow="clipboard-write" width="100%" height="100%"></iframe>"""
  return

# string string -> (element object -> void)
createLoader = (path, defaultId) ->
  scriptElem = scriptElement()
  scriptData = elementData(scriptElem)
  baseUrl    = scriptBase(scriptElem)
  url        = "#{baseUrl}#{path}"
  exposeAs   = common.intercap(scriptData.expose ? defaultId)

  initElement = (element, options = {}) ->
    defaults = options.defaults ? {}
    prefix   = options.prefix   ? ''
    options  = if prefix? then common.extend(defaults, elementData(element, prefix)) else defaults
    createIframe(element, url, options)
    return

  window[exposeAs] = initElement

  unless scriptData.noauto
    markerAttr = "data-" + common.hyphenate(scriptData.marker ? defaultId)
    onDomReady ->
      eachElement markerAttr, (element) ->
        initElement(element)
        return
      return

  return initElement

# Exports ---------------------------------------

module.exports = {
  createLoader
  scriptElement
  scriptBase
  elementData
}
